module.exports = __webpack_public_path__ + "static/media/pin.f57e4161.svg";